import { render, staticRenderFns } from "./BonusRuleConfig.vue?vue&type=template&id=957c51e6&scoped=true&"
import script from "./BonusRuleConfig.vue?vue&type=script&lang=js&"
export * from "./BonusRuleConfig.vue?vue&type=script&lang=js&"
import style0 from "./BonusRuleConfig.vue?vue&type=style&index=0&id=957c51e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957c51e6",
  null
  
)

export default component.exports